/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(function () {

  setTimeout(function () {
    resizePlansCards();
  }, 750);
  $(window).resize(function () {
    resizePlansCards();
  });
  $(".shogun-tab-box").click(function () {
    setTimeout(function () {
      resizePlansCards();
    }, 750);
  });
  function resizePlansCards() {
    const cols = $(".col");
    let heights = [];
    cols.each(function (index, el) {
      $(this)
        .find(".section-row")
        .each(function (index, element) {
          $(element).height("auto");
          if ($(window).width() < 768) {
            return;
          }
          let elementHeight = $(element).height();
          if (!heights[index] || heights[index] < elementHeight) {
            heights[index] = elementHeight;
          } else {
            heights[index] = heights[index];
          }
        });
    });
    cols.each(function (index, el) {
      $(this)
        .find(".section-row")
        .each(function (index, element) {
          $(element).height(heights[index] + "px");
        });
    });
  }

  $(document).on("click", "input#single", function () {
    var element = $(this);
    var parentElement = element.closest(".ProductForm");

    parentElement.removeClass("Subscriber");
    $(".subscribe-message").hide();
  });

  $(document).on("click", "input#subscribe", function () {
    var element = $(this);
    var parentElement = element.closest(".ProductForm");

    parentElement.addClass("Subscriber");
    $(".subscribe-message").show();
  });

  $(document).on("click", "input#quick-add-single", function () {
    var element = $(this);
    var parentElement = element.closest(".ProductForm");

    parentElement.removeClass("Subscriber");
    $(".subscribe-message").hide();
  });

  $(document).on("click", "input#quick-add-subscribe", function () {
    var element = $(this);
    var parentElement = element.closest(".ProductForm");

    parentElement.addClass("Subscriber");
    $(".subscribe-message").show();
  });
  
  
  
  
  $(document).on("click", "input.SizeSwatch__Radio", function () {
    var element = $(this);
	
	if (element.attr('name').includes('quick-add')) {
		if (element.attr('value') == '1 Jar') {
			if ($('#quick-add-shipping_interval_frequency_30').length) {
				$('#quick-add-shipping_interval_frequency_30').click();
			} else if ($('#quick-add-shipping_interval_frequency_24').length) {
				$('#quick-add-shipping_interval_frequency_24').click();
			}
		} else if (element.attr('value') == '2 Jars') {
			if ($('#quick-add-shipping_interval_frequency_60').length) {
				$('#quick-add-shipping_interval_frequency_60').click();
			} else if ($('#quick-add-shipping_interval_frequency_48').length) {
				$('#quick-add-shipping_interval_frequency_48').click();
			}
		} else if (element.attr('value') == '3 Jars') {
			if ($('#quick-add-shipping_interval_frequency_90').length) {
				$('#quick-add-shipping_interval_frequency_90').click();
			} else if ($('#quick-add-shipping_interval_frequency_36').length) {
				$('#quick-add-shipping_interval_frequency_36').click();
			}	
		} else if (element.attr('value') == '4 Jars') {
			if ($('#quick-add-shipping_interval_frequency_120').length) {
				$('#quick-add-shipping_interval_frequency_120').click();
			} else if ($('#quick-add-shipping_interval_frequency_96').length) {
				$('#quick-add-shipping_interval_frequency_96').click();
			}
		} else if (element.attr('value') == '6 Jars') {
			if ($('#quick-add-shipping_interval_frequency_180').length) {
				$('#quick-add-shipping_interval_frequency_180').click();
			} else if ($('#quick-add-shipping_interval_frequency_144').length) {
				$('#quick-add-shipping_interval_frequency_144').click();
			}
		}
	} else {
		if (element.attr('value') == '1 Jar') {
			if ($('#shipping_interval_frequency_30').length) {
				$('#shipping_interval_frequency_30').click();
			} else if ($('#shipping_interval_frequency_24').length) {
				$('#shipping_interval_frequency_24').click();
			}
		} else if (element.attr('value') == '2 Jars') {
			if ($('#shipping_interval_frequency_60').length) {
				$('#shipping_interval_frequency_60').click();
			} else if ($('#shipping_interval_frequency_48').length) {
				$('#shipping_interval_frequency_48').click();
			}
		} else if (element.attr('value') == '3 Jars') {
			if ($('#shipping_interval_frequency_90').length) {
				$('#shipping_interval_frequency_90').click();
			} else if ($('#shipping_interval_frequency_36').length) {
				$('#shipping_interval_frequency_36').click();
			}	
		} else if (element.attr('value') == '4 Jars') {
			if ($('#shipping_interval_frequency_120').length) {
				$('#shipping_interval_frequency_120').click();
			} else if ($('#shipping_interval_frequency_96').length) {
				$('#shipping_interval_frequency_96').click();
			}
		} else if (element.attr('value') == '6 Jars') {
			if ($('#shipping_interval_frequency_180').length) {
				$('#shipping_interval_frequency_180').click();
			} else if ($('#shipping_interval_frequency_144').length) {
				$('#shipping_interval_frequency_144').click();
			}
		}
	}

  });
  
  
  if (window.theme.pageType == 'product') {
	  $(document).ready(function(){
		  $(document).scroll(function() {
		    var y = $(this).scrollTop();
		    if (y > 800) {
			  $('.HorizontalList--spacingLoose:not(.Footer__Social) .HorizontalList__Item:not(.ProductQuickView):not(.HeaderCartButton)').addClass('HideAddToCart');
		      $('button.Header__Icon.quick-view').fadeIn();
		    } else {
		      $('button.Header__Icon.quick-view').fadeOut();
			  $('.HorizontalList--spacingLoose:not(.Footer__Social) .HorizontalList__Item:not(.ProductQuickView):not(.HeaderCartButton)').removeClass('HideAddToCart');
		    }
		  });
	  });
  }
  
  
  
  
  

  // Quick Add
  
  var product = '';	
var variants = '';
var recharge = '';
var discount_percentage = '';
var discount_percentage_decimal = '';
  var glasshouse_metafields = '';	
  var okendo_metafields = '';	
  var options_with_values = '';
var variantsMeta = '';	
  var currentVariant = '';
var option1 = '';
var option2 = '';
var option3 = '';
  var masterSelector = '';

var default_purchase_type = false;


var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

$(document).on('click', 'button.quick-view', function () {
  $('#sidebar-cart .Drawer__Close').click();
$('.PageOverlay').addClass('is-visible');
  
  var product_handle = $(this).attr('data-handle');	
	
  jQuery.get('/products/' + product_handle + '?view=json', function (response) {
	
    response = JSON.parse(response);
  
  console.log(response);
  
    product = response.product;	
    glasshouse_metafields = response.glasshouse_metafields;	
  discount_percentage = parseInt(response.recharge.discount_percentage);
  discount_percentage_decimal = response.recharge.discount_percentage / 100;	
    okendo_metafields = response.okendo_metafields;	
    options_with_values = response.options_with_values;
  variantsMeta = response.variants;	
  currentVariant = product.variants[0];
    option1 = product.variants[0]['option1'];
    option2 = product.variants[0]['option2'];
    option3 = product.variants[0]['option3'];

    var title = product.title;
  
  var tags = product.tags;
  var labels = '';
  
  var price = Shopify.formatMoney((Math.round(product.price) / 100).toFixed(2),window.theme.moneyWithCurrencyFormat);
  var afterpayPrice = Shopify.formatMoney((Math.round(product.price * 0.25) / 100).toFixed(2),window.theme.moneyWithCurrencyFormat);
  var subscribePrice = Shopify.formatMoney((Math.round(product.price * (1 - discount_percentage_decimal)) / 100).toFixed(2),window.theme.moneyWithCurrencyFormat);
  
  $(tags).each(function (i, tag) {
	  if (tag.includes('Label_')) {
		  tag = tag.replace("Label_", "");
		  labels = labels + '<span class="ProductItem__Label ProductItem__Label--' + tag + ' Heading Text--subdued">' + tag + '</span>';
	  };	  
  });
  
  $('#quick-add-drawer .ProductMeta__Title').text(title);
  $('#quick-add-drawer .ProductItem__LabelList').html(labels);
  
  if (default_purchase_type) {
	  $('#quick-add-drawer .ProductForm').addClass('Subscriber');
  } else {
	  $('#quick-add-drawer .ProductForm').removeClass('Subscriber');
  }
  
  if (okendo_metafields.ProductListingSnippet) {
	  $('#quick-add-drawer .prod__reviews').html(okendo_metafields.ProductListingSnippet);
  }
  
  $('#quick-add-drawer form').attr('id', 'quick-add-product_form_' + product.id);
  $('#quick-add-drawer form').attr('data-productid', product.id);
  
  var html = '';

  html += '<div class="ProductForm__Variants">';	  
  
  variants = product.variants;
  
  html += '<span class="ProductForm__Label">Buying Options:</span>';
  html += '<div class="ProductForm__Option SubscribeSelect">';
  html += '		<ul class="SizeSwatchList HorizontalList HorizontalList--spacingTight">';
  html += '			<li class="HorizontalList__Item">';
  
  if (default_purchase_type) {
	  html += '				<input id="quick-add-single" class="SizeSwatch__Radio" type="radio" name="subscribe" value="false" price="0">';
  } else {
	  html += '				<input id="quick-add-single" class="SizeSwatch__Radio" type="radio" name="subscribe" value="true" checked="checked" price="0">';
  }
  
  html += '				<label for="quick-add-single" class="SizeSwatch">One Time Purchase';
  html += '					<div class="ProductMeta__PriceList Heading"><span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible=""><span class="money">' + price + '</span></span></div>';
  html += '				</label>';
  html += '			</li>';
  html += '			<li class="HorizontalList__Item">';
  
  if (default_purchase_type) {
	  html += '				<input id="quick-add-subscribe" class="SizeSwatch__Radio" type="radio" name="subscribe" value="true" checked="checked" price="0">';
  } else {
	  html += '				<input id="quick-add-subscribe" class="SizeSwatch__Radio" type="radio" name="subscribe" value="false" price="0">';
  }
  
  html += '				<label for="quick-add-subscribe" class="SizeSwatch">Subscribe &amp; Save ' + discount_percentage + '%';
  html += '					<div class="ProductSubscribe__PriceList Heading"><span class="ProductSubscribe__Price Price Text--subdued u-h4" data-money-convertible=""><span class="money">' + subscribePrice + '</span></span></div>';
  html += '				</label>';
  html += '			</li>';
  html += '		</ul>';
  html += '</div>';
  
  $(options_with_values).each(function (index, option) {
	  if (option.name == 'Flavour123') {
	  		
		  var popover_id = 'quick-add-popover-product-template-flavour';
			
		  html += '<button type="button" class="ProductForm__Item" aria-expanded="false" data-action="open-popover" aria-controls="' + popover_id + '">';
            html += '<span class="ProductForm__OptionName">' + option.name + ': <span class="ProductForm__SelectedValue">' + option.selected_value + '</span></span><svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12"><polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline></svg>';
		  html += '</button>';
			
		  html += '<div class="Product__OffScreen">';
		  html += '	<div id="' + popover_id + '" class="OptionSelector Popover Popover--withMinWidth Popover--positionLeft Popover--alignCenter" aria-hidden="true">';
		  
		  var option_index = 'option' + option.position;

		  html += '		<header class="Popover__Header">';
		  html += '			<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14"><path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path></svg></button>';
		  html += '			<span class="Popover__Title Heading u-h4">' + option.name + '</span>';
		  html += '		</header>';
		  
		  html += '		<div class="Popover__Content">';
		  html += '			<div class="Popover__ValueList" data-scrollable>';
		  
		  $(option.values).each(function (index, value) {
			  if (value == option.selected_value) {
				  html += '			<button type="button" class="Popover__Value is-selected Heading Link Link--primary u-h6" value="' + value + '" data-option-position="' + option.position + '" data-action="quick-add-select-value">';
			  } else {
				  html += '			<button type="button" class="Popover__Value Heading Link Link--primary u-h6" value="' + value + '" data-option-position="' + option.position + '" data-action="quick-add-select-value">';
			  };
			  
			  html += value;
			  html += '			</button>';
		  });
		  
		  html += '		</div>';
		  html += '	</div>';
		  html += '</div>';
			
	  } else {
		  var optionIndex = 'option' + option.position;
 
		  html += '	<div class="ProductForm__Option ProductForm__Option--labelled">';
		  html += '		<span class="ProductForm__Label">' + option.name + '</span>';
		  html += '			<ul class="SizeSwatchList HorizontalList HorizontalList--spacingTight">';
	  
		  $(option.values).each(function (j, value) {
		  			  
			  html += '				<li class="HorizontalList__Item">';
		  
			  if (j == 0) {
				  html += '					<input id="quick-add-option-product-template-' + index + '-' + j + '" class="SizeSwatch__Radio" type="radio" name="quick-add-option-' + index + '-quick-add" value="' + value + '" checked="checked" data-option-position="' + option.position + '">';
			  } else {
				  html += '					<input id="quick-add-option-product-template-' + index + '-' + j + '" class="SizeSwatch__Radio" type="radio" name="quick-add-option-' + index + '-quick-add" value="' + value + '" data-option-position="' + option.position + '">';
			  };


			  html += '					<label for="quick-add-option-product-template-' + index + '-' + j + '" class="SizeSwatch">' + value;
		  
			  var products_in_pack = parseInt(value.split(" ")[0]);
		  	  
			  if (!isNaN(products_in_pack)) {
				  var min_price_for_variant = product.price;
			  
				  $(product.variants).each(function (k, variant) {
					  if (variant[optionIndex] == value) {
						  min_price_for_variant = variant.price;
					  };
				  });
			  
				  html += '						<span class="ProductMeta__VariantData">';
				  html += '							<span class="VariantData_Copy Single VariantData_Price Text--subdued">';
				  html += '								<span class="money"><span class="money">' + Shopify.formatMoney((Math.round(min_price_for_variant / products_in_pack) / 100).toFixed(2),window.theme.moneyWithCurrencyFormat) + ' each</span></span>';
				  html += '							</span>';
			  
				  html += '							<span class="VariantData_Copy Subscribe VariantData_Price Text--subdued">';
				  html += '								<span class="money"><span class="money">' + Shopify.formatMoney((Math.round(min_price_for_variant / products_in_pack * (1 - discount_percentage_decimal)) / 100).toFixed(2),window.theme.moneyWithCurrencyFormat) + ' each</span></span>';
				  html += '							</span>';
			  
				  html += '						</span>';
			  }

			  html += '					</label>';
			  html += '				</li>';
	 
		  });
	  
		  html += '			</ul';
		  html += '		</span>';
		  html += '	</div>';
	  }
  });
  
  html += '</div>';	
  
  html += '<p class="afterpay-paragraph" style="" data-product-id="' + product.id + '"><span class="afterpay-text1">or 4 interest-free payments of </span><strong class="afterpay-instalments">' + afterpayPrice + '</strong><span class="afterpay-text2"> with </span><a class="afterpay-link" href="https://www.afterpay.com/terms" target="_blank"><img class="afterpay-logo" style="vertical-align:middle;" src="https://static.afterpay.com/integration/product-page/logo-afterpay-colour.png" srcset="https://static.afterpay.com/integration/product-page/logo-afterpay-colour.png 1x, https://static.afterpay.com/integration/product-page/logo-afterpay-colour@2x.png 2x, https://static.afterpay.com/integration/product-page/logo-afterpay-colour@3x.png 3x" width="100" height="21" alt="Afterpay"></a></p>';
  
  if (response.recharge) {
	  html += '<div class="subscribe-message">';
	  html += '	<span class="ProductForm__Label">Delivered every:</span>';	
	  
	  var shipping_interval_unit_type = response.recharge.shipping_interval_unit_type;
	  var shipping_interval_frequency = response.recharge.shipping_interval_frequency.split(',');
	  
	  html += '	<div class="ProductForm__Option FrequencySelect">';	
	  html += '		<ul class="SizeSwatchList HorizontalList HorizontalList--spacingTight">';	
	  
	  $(shipping_interval_frequency).each(function (index, shipping_interval) {
		  html += '			<li class="HorizontalList__Item">';
		  if (index == 0) {
			  html += '				<input id="quick-add-shipping_interval_frequency_' + shipping_interval + '" class="SizeSwatch__Radio" type="radio" rc_shipping_interval_unit_type="' + shipping_interval_unit_type + '" rc_shipping_interval_frequency="' + shipping_interval + '" name="quick-add-shipping_interval" value="true" checked>';
		  } else {
			  html += '				<input id="quick-add-shipping_interval_frequency_' + shipping_interval + '" class="SizeSwatch__Radio" type="radio" rc_shipping_interval_unit_type="' + shipping_interval_unit_type + '" rc_shipping_interval_frequency="' + shipping_interval + '" name="quick-add-shipping_interval" value="false">';
		  }
		  
		  html += '				<label for="quick-add-shipping_interval_frequency_' + shipping_interval + '" class="SizeSwatch">' + shipping_interval + ' ' + shipping_interval_unit_type + '</label>';
		  html += '			</li>';
	  });
	  
	  html += '		</ul>';
	  html += '	</div>';
	  html += '</div>';
  }
  
  html += '<div class="no-js ProductForm__Option">';
  html += '	<div class="Select Select--primary">';
  html += '		<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12"><polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline></svg>';
  html += '		<select id="quick-add-product-select-' + product.id + '" name="id" title="Variant" data-productid="' + product.id + '">';
  
  $(variants).each(function (j, variant) {
	  var variantSubscriptionId = '';
	 
	  $(variantsMeta).each(function (k, variantMeta) {
		  if (variantMeta.variantId == variant.id) {
			  variantSubscriptionId = variantMeta.variantSubscriptionId;
			  return false;
		  }
	  });
	  
	  if (j == 0) {
		  html += '			<option selected="selected" value="' + variant.id + '" data-sku="' + variant.sku + '" data-subscription-id="' + variantSubscriptionId + '">' + variant.title + ' - ' + variant.price + ' </option>';
	  } else {
		  html += '			<option value="' + variant.id + '" data-sku="' + variant.sku + '" data-subscription-id="' + variantSubscriptionId + '">' + variant.title + ' - ' + variant.price + ' </option>';
	  }
  });

  html += '		</select>';
  html += '	</div>';
  html += '</div>';
  html += '<input type="hidden" name="quantity" value="1">';
  	  
  $('#quick-add-drawer .FormContents').html(html);
  masterSelector = document.querySelector('#quick-add-product-select-' + product.id);
  
  });

});

$(document).on('click', '[data-action="open-popover"]', function () {
  var activator = $(this)[0];

  var popOverId = $(this).attr('aria-controls');

  var topPosition = 0,
  	rightPosition = 0,
  	position = 'left',
  	alignment = 'center',
  	threshold = 20;

  var windowHeight = window.innerHeight,
  	activatorBoundingRect = activator.getBoundingClientRect(),
  	halfHeight = windowHeight / 2;
  
  rightPosition = window.innerWidth - activatorBoundingRect.left + threshold;
  topPosition = activatorBoundingRect.top + activatorBoundingRect.height / 2;

  $('#' + popOverId).attr('aria-hidden','false');
  $('#' + popOverId)[0].setAttribute('style', 'transform: translateY(-50%); top: ' + parseInt(topPosition) + 'px; right: ' + parseInt(rightPosition) + 'px;');
});
  
function _onOptionChanged(target) {
  	  
  var data_option_position = target[0].getAttribute('data-option-position');
  	  
  if (data_option_position == 1) {
	  option1 = target.val();
  } else if (data_option_position == 2) {
	  option2 = target.val();
  } else if (data_option_position == 3) {
	  option3 = target.val();
  }

  // Finally, we get the new variant
  previousVariant = currentVariant;
  currentVariant = _getCurrentVariantFromOptions();

  _onVariantChanged(previousVariant, currentVariant);

  if (currentVariant) {
    // We need to modify the hidden select that contain the id attribute as well
    masterSelector.querySelector('[selected]').removeAttribute('selected');
    masterSelector.querySelector('[value="' + currentVariant['id'] + '"]').setAttribute('selected', 'selected');
  }
};

function _getCurrentVariantFromOptions() {
  var found = false;

  variants.forEach(function (variant) {
	  if (variant['option1'] === option1 && variant['option2'] === option2 && variant['option3'] === option3) {
		  found = variant;
	  }
  });

  return found || null;
}

  function _addToCart(event) {

	var addToCartButton = document.querySelector('#quick-add-drawer .ProductForm__AddToCart');

	// First, we switch the status of the button
	addToCartButton.setAttribute('disabled', 'disabled');
	document.dispatchEvent(new CustomEvent('theme:loading:start'));

	// Then we add the product in Ajax
	var formElement = document.querySelector('#quick-add-drawer form[action*="/cart/add"]');

	if ($('#quick-add-drawer #quick-add-subscribe').length && $('#quick-add-drawer #quick-add-subscribe').is(':checked') == true) {
		var subscribeId = formElement.querySelector('[name="id"] option:checked').getAttribute('data-subscription-id');
		
		var shipping_interval_frequency = $('#quick-add-drawer [name="quick-add-shipping_interval"]:checked').attr('rc_shipping_interval_frequency');
		var shipping_interval_unit_type = $('#quick-add-drawer [name="quick-add-shipping_interval"]:checked').attr('rc_shipping_interval_unit_type');

	    fetch(window.routes.cartAddUrl + '.js', {
	      body: JSON.stringify({ 
			  id: subscribeId, 
			  quantity: 1,
			  properties: {
				  shipping_interval_frequency: shipping_interval_frequency,
				  shipping_interval_unit_type: shipping_interval_unit_type
			  }
		  }),
	      credentials: 'same-origin',
	      method: 'POST',
	      headers: {
	        'Content-Type': 'application/json',
	        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
	      }
	    }).then(function (response) {
	      document.dispatchEvent(new CustomEvent('theme:loading:end'));
	      if (response.ok) {
	        addToCartButton.removeAttribute('disabled');
	        // We simply trigger an event so the mini-cart can re-render
	        document.dispatchEvent(new CustomEvent('product:added', {
	          bubbles: true,
	          detail: {
	            variant: currentVariant,
	            quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
	          }
	        }));
	      } else {
	        response.json().then(function (content) {
	          var errorMessageElement = document.createElement('span');
	          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
	          errorMessageElement.innerHTML = content['description'];
	          addToCartButton.removeAttribute('disabled');
	          addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
	          setTimeout(function () {
	            errorMessageElement.remove();
	          }, 2500);
	        });
	      }
	    });
	} else {
		var variantId = formElement.querySelector('[name="id"] option:checked').value;

	    fetch(window.routes.cartAddUrl + '.js', {
	      body: JSON.stringify({ 
			  id: variantId, 
			  quantity: 1
		  }),
	      credentials: 'same-origin',
	      method: 'POST',
	      headers: {
	        'Content-Type': 'application/json',
	        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
	      }
	    }).then(function (response) {
	      document.dispatchEvent(new CustomEvent('theme:loading:end'));
	      if (response.ok) {
	        addToCartButton.removeAttribute('disabled');
	        // We simply trigger an event so the mini-cart can re-render
	        document.dispatchEvent(new CustomEvent('product:added', {
	          bubbles: true,
	          detail: {
	            variant: currentVariant,
	            quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
	          }
	        }));
	      } else {
	        response.json().then(function (content) {
	          var errorMessageElement = document.createElement('span');
	          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
	          errorMessageElement.innerHTML = content['description'];
	          addToCartButton.removeAttribute('disabled');
	          addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
	          setTimeout(function () {
	            errorMessageElement.remove();
	          }, 2500);
	        });
	      }
	    });
	}
	
      if (window.reChargeCartJS) {
  		  window.reChargeCartJS();
      }

}

function _updateProductPrices(newVariant, previousVariant) {
      var productMetaPrices = document.querySelector('#quick-add-drawer .ProductMeta__PriceList');
	var productSubscribePrices = document.querySelector('#quick-add-drawer .ProductSubscribe__PriceList');

      if (!newVariant) {
        productMetaPrices.style.display = 'none';
	  if (productSubscribePrices) {
          productSubscribePrices.style.display = 'none';
	  }
  
      } else {
        if (previousVariant && previousVariant['price'] === newVariant['price'] && previousVariant['compare_at_price'] === newVariant['compare_at_price']) {
          return; // The price do not have changed so let's return to avoid changing the DOM for nothing
        }

        productMetaPrices.innerHTML = '';
	  if (productSubscribePrices) {
          productSubscribePrices.innerHTML = '';
	  }

        if (newVariant['compare_at_price'] > newVariant['price']) {
          productMetaPrices.innerHTML += '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>' + Shopify.formatMoney(newVariant['price'], window.theme.moneyFormat) + '</span>';
          productMetaPrices.innerHTML += '<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>' + Shopify.formatMoney(newVariant['compare_at_price'], window.theme.moneyFormat) + '</span>';
		if (productSubscribePrices) {
            productSubscribePrices.innerHTML += '<span class="ProductSubscribe__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>' + Shopify.formatMoney((Math.round(newVariant['price'] * (1 - discount_percentage_decimal)) / 100).toFixed(2),window.theme.moneyWithCurrencyFormat) + '</span>';
            productSubscribePrices.innerHTML += '<span class="ProductSubscribe__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>' + Shopify.formatMoney((Math.round(newVariant['compare_at_price'] * (1 - discount_percentage_decimal)) / 100).toFixed(2),window.theme.moneyWithCurrencyFormat) + '</span>';
		}
	  } else {
          productMetaPrices.innerHTML += '<span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible>' + Shopify.formatMoney(newVariant['price'], window.theme.moneyFormat) + '</span>';
		if (productSubscribePrices) {
            productSubscribePrices.innerHTML += '<span class="ProductSubscribe__Price Price Text--subdued u-h4" data-money-convertible>' + Shopify.formatMoney((Math.round(newVariant['price'] * (1 - discount_percentage_decimal)) / 100).toFixed(2),window.theme.moneyWithCurrencyFormat) + '</span>';
		}
	  }

        productMetaPrices.style.display = '';
	  if (productSubscribePrices) {
          productSubscribePrices.style.display = '';
	  }
      }
    }

function _onVariantChanged(previousVariant, newVariant) {
	// 1st: the prices
	_updateProductPrices(newVariant, previousVariant);

	// 2nd: update inventory
	//this._updateInventory(newVariant, previousVariant);

	// 3rd: update SKU
	//this._updateSku(newVariant, previousVariant);

	// 4th: update the price measurement
	//this._updateUnitPrice(newVariant, previousVariant);

	// 5th: the add to cart button
	//this._updateAddToCartButton(newVariant, previousVariant);

	// Finally, we send an event so that other system could hook and do their own logic
	document.documentElement.dispatchEvent(new CustomEvent('variant:changed', {
		bubbles: true,
		detail: { variant: newVariant, previousVariant: previousVariant }
	}));
}

$(document).on('change', '#quick-add-drawer .ProductForm__Option [type="radio"]', function () {
	_onOptionChanged($(this));
});

$(document).on('click', '#quick-add-drawer [data-action="quick-add-select-value"]', function () {
	console.log('clicked pop over value');
	_onOptionChanged($(this));
});

$(document).on('click', '[data-action="quick-add-to-cart"]', function (event) {
      event.preventDefault(); // Prevent form to be submitted
	$('#quick-add-drawer .Drawer__Close').click();
	_addToCart();
});


	IPRedirect.init({"heading_color":"#54585a","text_color":"#54585a","text_light_color":"#54585a","link_color":"#d7b6b5","background":"#fafafa","light_background":"#ffffff","product_on_sale_color":"#f94c43","button_background":"#66ceaa","button_text_color":"#ffffff","header_background":"#ffffff","header_heading_color":"#54585a","header_light_color":"#54585a","footer_background":"#ffffff","footer_heading_color":"#54585a","footer_text_color":"#54585a","navigation_background":"#ffffff","navigation_text_color":"#54585a","newsletter_popup_background":"#54585a","newsletter_popup_text_color":"#ffffff","secondary_elements_background":"#54585a","secondary_elements_text_color":"#ffffff","business_name":"Happy Mammoth LLC","business_address":"1000 Brickell Ave, PMB 5007 Ste 715, Miami, FL 33131-3047","heading_font":{"error":"json not allowed for this object"},"heading_font_custom":"Cabin","heading_size":"large","uppercase_heading":false,"text_font":{"error":"json not allowed for this object"},"text_font_custom":"Cabin","base_text_font_size":17,"show_page_transition":false,"show_button_transition":false,"show_image_zooming":false,"show_element_staggering":false,"search_mode":"product,article","product_show_price_on_hover":false,"product_show_secondary_image":true,"product_info_alignment":"center","product_image_size":"natural","product_list_horizontal_spacing":"extra_small","product_list_vertical_spacing":"extra_small","cart_type":"drawer","cart_enable_notes":false,"cart_show_free_shipping_threshold":false,"cart_free_shipping_threshold":"300","social_facebook":"https:\/\/www.facebook.com\/thehappymammoth\/","social_twitter":"","social_pinterest":"","social_instagram":"https:\/\/www.instagram.com\/thehappymammoth\/","social_vimeo":"","social_tumblr":"","social_youtube":"","social_linkedin":"","social_snapchat":"","social_fancy":"","gtm_id":"GTM-M6983L7","default_purchase_type":false,"favicon":"\/\/cdn.shopify.com\/s\/files\/1\/1531\/8007\/files\/Favicon_a34d277d-a4d7-4227-bbbc-ea3b6cd2a3bd.png?v=1602953798","redirect_use":true,"redirect_relative":true,"redirect_force":true,"ip_white_list":"180.150.28.133","redirect_catch_all_countries":"US","redirect_catch_all_url":"https:\/\/store.happymammoth.com","redirect_catch_all_name":"US SITE","redirect_catch_all_countries2":"","redirect_catch_all_url2":"","redirect_catch_all_name2":"","dns_prefetch_domains":"cdn.shopify.com,www.googletagmanager.com,www.google-analytics.com","dns_preconnect_domains":"https:\/\/cdn.shopify.com,https:\/\/www.google.com,https:\/\/www.google.com.au,https:\/\/stats.g.doubleclick.net,connect.facebook.net,https:\/\/fonts.googleapis.com","checkout_header_image":"","checkout_logo_image":"shopify:\/\/shop_images\/HM_Logo_Black_1.png","checkout_logo_position":"center","checkout_logo_size":"large","checkout_body_background_image":"","checkout_body_background_color":"#ffffff","checkout_input_background_color_mode":"white","checkout_sidebar_background_image":"","checkout_sidebar_background_color":"#eef8f6","checkout_heading_font":"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'","checkout_body_font":"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'","checkout_accent_color":"#bde1f1","checkout_button_color":"#00d6a4","checkout_error_color":"#e32c2b","mlvedaACS_roundDecimal":true,"mlvedaACS_positionTop":false,"mlvedaACS_positionRight":false,"mlvedaACS_positionLeft":"0px","mlvedaACS_defaultCurrency":"AUD","mlvedaACS_positionBottom":"0px","mlvedaACS_position":"bottom_with_left","mlvedaACS_enable":true,"mlvedaACS_supportedCurrencies":"AUD EUR GBP USD","mlvedaACS_hideDecimal":false,"mlvedaACS_currencyFormat":"money_with_currency_format","mlvedaACS_displayFlag":true,"customer_layout":"customer_area"});
	IPRedirect.run();

});